import { render } from "./NfseIssue.vue?vue&type=template&id=5b630c78"
import script from "./NfseIssue.vue?vue&type=script&lang=js"
export * from "./NfseIssue.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__